<script lang="ts" setup>
export interface HandDetailTitleProps {
  bigBlind: number
  smallBlind: number
  straddle?: number
  ante?: number
  variant?: string
  gameformatGroup: string
}
defineProps<HandDetailTitleProps>()
</script>
<template>
  {{ smallBlind }} / {{ bigBlind }}
  <span v-if="straddle"> / {{ straddle }} </span>
  <span v-if="ante"> ({{ ante }}) </span>
  <span v-if="variant"> ({{ variant }}) </span>
  <span v-if="gameformatGroup">
    {{ $t(`gametypes.groups.${gameformatGroup.toLowerCase()}`) }}
  </span>
</template>
